<ng-container *ngIf="policy?.hasAffinityGroup && !hideAffinityAlert">
    <div class="notice-container affinity-border-color">
        <div class="info-icon-block"  [ngClass]="{ 'acmic-info-icon-rounded': isAcmic }">
            <img src="./assets/img/images/icon-info-32.svg" alt="success icon" />
        </div>
        <div class="notice-info-block">
            <div class="row-space-between align-items-start">
                <div class="main-notice-info">{{ 'The billing on this policy is being handled by your agent' }}</div>
                <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer ml-3" alt="close icon"
                        (click)="onClose()" />
            </div>

            <hr class="thin-hr-mb-24 mb-0 mt-0">

            <div class="bn-content-text" [ngClass]="{ 'col-363636': isAcmic }">
                <div class="bn-contact-agent bn-agent-text">
                    <ng-container *ngIf="isAcmic; else maAssistance">
                        <div class="font-weight-500 mb-1">
                                Contact us for assistance
                        </div>
                        <div class="bn-contact-agent-info">
                            <div class="bn-agent-phone mt-0 mb-2">
                                <div>
                                    {{ 'PHONE' | translate }}
                                </div>
                                <div class="ml-1">
                                    <a href="tel:1-844-295-4500" class="mapfre link dash-red-color fs-16">
                                        {{ '1-844-295-4500' }}</a>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #maAssistance>
                        <div class="font-weight-500 mb-2">
                            Contact your agent for assistance
                        </div>
                        <div class="d-flex flex-wrap">
                            <div class="mr-3 mb-2">{{ agentName }}</div>
                            <div class="phone-block" *ngIf="agentPhoneNumber">
                                {{ 'PHONE' | translate }}
                                <span class="ml-1">
                                    <a href="tel:{{agentPhoneNumber}}" class="mapfre link dash-red-color">
                                        {{ agentPhoneNumber | formatPhone }}</a>
                                </span>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</ng-container>